import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-parking-icon"
};
const _hoisted_1 = {
  width: "15",
  height: "16",
  viewBox: "0 0 15 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_3154_580)"><path opacity="0.2" d="M12.7778 1H2.77783C1.67327 1 0.777832 1.89544 0.777832 3V13C0.777832 14.1046 1.67327 15 2.77783 15H12.7778C13.8825 15 14.7778 14.1046 14.7778 13V3C14.7778 1.89544 13.8825 1 12.7778 1ZM8.27783 10H6.77783V11C6.77783 11.5527 6.33058 12 5.77783 12C5.22508 12 4.77783 11.5527 4.77783 11V5C4.77783 4.44725 5.22508 4 5.77783 4H8.27783C9.93214 4 11.2778 5.34569 11.2778 7C11.2778 8.65431 9.93214 10 8.27783 10ZM8.27783 6H6.77783V8H8.27783C8.82958 8 9.27783 7.55175 9.27783 7C9.27783 6.44825 8.82958 6 8.27783 6Z"></path><path d="M8.27783 4H5.77783C5.22508 4 4.77783 4.44725 4.77783 5V11C4.77783 11.5527 5.22508 12 5.77783 12C6.33058 12 6.77783 11.5527 6.77783 11V10H8.27783C9.93214 10 11.2778 8.65431 11.2778 7C11.2778 5.34569 9.93214 4 8.27783 4ZM8.27783 8H6.77783V6H8.27783C8.82958 6 9.27783 6.44825 9.27783 7C9.27783 7.55175 8.82958 8 8.27783 8Z"></path></g><defs><clipPath id="clip0_3154_580"><rect width="14" height="16" fill="white" transform="translate(0.777832)"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitParkingIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitParkingIcon as default
};
//# sourceMappingURL=uikit-parking-icon.vue.es.js.map
